// extracted by mini-css-extract-plugin
export default {"link_card":"index-module__link_card--JwEHc","link_card_image":"index-module__link_card_image--NCGwp","link_card_color":"index-module__link_card_color--CK9HY"};